import { createStyles } from 'antd-style'

import { BasicProps } from '@eastcoal/common/types/component'

import { AuctionDetailBidForm } from './BidForm'
import { AuctionDetailTipCard } from './TipCard'

const useStyles = createStyles(({ prefixCls, token }) => ({
  container: {
    padding: token.paddingMD,
    borderRadius: token.borderRadiusSM,
    backgroundColor: token.colorFillContent
  }
}))

export const AuctionDetailBidActionPanel = ({
  className,
  style
}: BasicProps) => {
  const { cx, styles } = useStyles()

  return (
    <div className={cx(styles.container, className)} style={style}>
      <AuctionDetailBidForm />
      <AuctionDetailTipCard />
    </div>
  )
}
